import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.st = new SmartTable();
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/administrators-developers/administrators-developers.controller.js